import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/vbi-wall.jpg' satisfies MediaPath
const guide = 'portfolio/vbi-cover-mockup2.jpg' satisfies MediaPath
const posters = 'portfolio/vbi-posters-mockup1.jpg' satisfies MediaPath
const pin = 'portfolio/vbi-pin-picture.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'vbi',
	name: 'VBI',
	excerpt: 'Brand identity for the Virginia Bioinformatics Institute',
	tags: ['design', 'branding'],
	cover,
	featured: true,
	order: 25,
}

export default function Vbi() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">Identity</h2>
			<p>
				A mark and system for the Virginia Bioinformatics Institute — a lowercase “vbi” wordmark
				whose connective nodes read as networks and sequence without leaning on the usual helix
				cliché.
			</p>
			<h2 className="font-bold text-xl">System</h2>
			<p>
				The brand, identity, and style guidelines codify the logo, generative cover artwork, type,
				and color — carried through a research poster series and event collateral for the 2015
				Research Symposium.
			</p>
			<Gallery
				items={[
					{
						src: cover,
						alt: 'vbi dimensional wordmark on stone',
					},
					{
						src: guide,
						alt: 'Brand & style guidelines cover',
					},
					{
						src: posters,
						alt: 'Microfluidics — research poster series',
					},
					{
						src: pin,
						alt: 'Research Symposium lapel pin',
					},
				]}
			/>
		</>
	)
}
